<template>
  <v-container fluid class="pa-0">
    <div v-if="brandbar_show">
      <!-- Header -->
      <v-row
        id="v-app-bar--container"
        class="city-header d-flex align-center no-wrap pa-2 pt-0"
        no-gutters
      >
        <!-- Left: Badge -->
        <v-col class="flex-grow-0 flex-shrink-0 pr-0">
          <a href="https://renopd.com/" title="Reno PD .com">
            <img src="../images/gold-badge.png" class="badge-img pl-2" />
          </a>
        </v-col>

        <!-- Middle: Title (flexes, can shrink, never forces wrap) -->
        <v-col class="title-col white--text pl-2 pt-4 pt-md-5">
          <div class="mb-0">THE RENO</div>
          <div class="mb-0">POLICE DEPARTMENT</div>
          <div class="font-italic mb-0">Your Police, Our Community</div>
        </v-col>

        <!-- Desktop buttons: pinned right, only md+ -->
        <v-col
          class="flex-grow-0 flex-shrink-0 d-none d-md-flex align-center pr-0"
        >
          <v-btn
            href="https://iaforms.renopd.com/"
            target="_blank"
            title="Contact Us"
            class="join-btn join-btn-contact mr-4"
            depressed
            elevation="2"
          >
            <span>Contact</span>
            <span>Us</span>
          </v-btn>

          <v-btn
            href="https://www.renopd.us/"
            target="_blank"
            title="Join Our Team"
            class="join-btn join-btn-team mr-4"
           
            depressed
            elevation="2"
          >
            <span>Join Our</span>
            <span>Team!</span>
          </v-btn>
        </v-col>

        <!-- Right: City logo -->
        <v-col class="flex-grow-0 flex-shrink-0 pr-0 d-flex justify-end">
          <a
            href="https://www.reno.gov/"
            target="_blank"
            title="City of Reno Home Page"
          >
            <img src="../images/city.png" class="city-img" />
          </a>
        </v-col>
      </v-row>

      <!-- Blue bar -->
      <div id="app-title-container" class="d-flex" style="width: 100%">
        <div id="blue-bar" class="mb-2">
          <v-row
            id="blue-bar-flex"
            class="d-flex align-center justify-space-between no-wrap pa-2"
            no-gutters
          >
            <v-col class="flex-grow-1 flex-shrink-1 px-0">
              <rpd_menu></rpd_menu>
            </v-col>

            <!-- Mobile buttons: only sm and down -->
            <v-col class="flex-grow-0 flex-shrink-0 d-flex d-md-none px-0">
              <v-btn
                href="https://renopd.com/Recruit"
                target="_blank"
                title="Join Our Team"
                class="join-btn-mobile mr-2"
         
                depressed
                elevation="2"
              >
                Join Our Team!
              </v-btn>
              <v-btn
                  href="https://iaforms.renopd.com/"
                  target="_blank"
                  title="Contact Us"
                  class="join-btn-mobile mr-10"
                
                  depressed
                  elevation="2"
                  >
                  Contact<br />Us
              </v-btn>
              <div style="width:40px;height: 1px;"> </div>
              <!-- <v-btn
                href="https://renopd.com/cadets"
                target="_blank"
                title="Join Jr. Cadets"
                class="join-btn-mobile"
                small
                depressed
                elevation="2"
              >
                Join Jr Cadets!
              </v-btn> -->
            </v-col>
          </v-row>
        </div>

        <v-spacer></v-spacer>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
/* ----- Shared helpers ----- */
.no-wrap {
  flex-wrap: nowrap !important;
}

/* ----- Header background and sizing ----- */
#v-app-bar--container {
  background-image: url(../images/jm-Header2.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Mobile header height */
.city-header {
  height: 67px;
  align-items: flex-start;
}

/* Images */
.badge-img {
  width: 53px !important;
}

.city-img {
  width: 25px;
}

/* Title sizing */
.title-col {
  line-height: 0.8rem;
  font-size: 12px;
  font-weight: 500;
  min-width: 0;
}

/* ----- Blue bar ----- */
#blue-bar {
  background-color: #002e42 !important;
  color: white !important;
  max-width: 768px;
  width: 100%;
  height: 3.8em;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 0px;
  -webkit-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
}

/* ----- Shared button appearance ----- */
.join-btn,
.join-btn-mobile {
  background-color: #4587c1 !important;
  color: #fff !important;
  text-transform: none;
  border-radius: 2px;
}

/* ----- Shared deep button control ----- */
:deep(.join-btn.v-btn),
:deep(.join-btn-mobile.v-btn) {
  min-width: 0 !important;
  padding: 0 !important;
  color: #fff !important;
}

:deep(.join-btn .v-btn__content),
:deep(.join-btn-mobile .v-btn__content) {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  white-space: normal !important;
  text-align: center;
  letter-spacing: 0 !important;
  line-height: 1.15 !important;
  padding: 0 !important;
}

/* ----- Mobile button sizing ----- */
:deep(.join-btn-mobile.v-btn) {
  min-height: 48px !important;
  height: auto !important;
  padding: 0 8px !important;
}

.join-btn-mobile {
  font-size: 11px;
}

/* ----- Desktop / tablet ----- */
@media (min-width: 768px) {
  .city-header {
    height: 97px;
    align-items: center;
  }

  .badge-img {
    width: 77px !important;
  }

  .city-img {
    width: 35px;
  }

  .title-col {
    line-height: 1;
    font-size: 1.2rem !important;
    font-weight: 500;
  }

  #blue-bar {
    height: 2.5em;
  }

  /* Desktop button root sizing */
  :deep(.join-btn.v-btn) {
    height: 84px !important;
    min-height: 84px !important;
    padding: 0 10px !important;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 1), 0 2px 10px 0 rgba(0, 0, 0, 1);
  }

  :deep(.join-btn-contact.v-btn) {
    width: 126px !important;
    min-width: 126px !important;
  }

  :deep(.join-btn-team.v-btn) {
    width: 86px !important;
    min-width: 86px !important;
  }

  .join-btn {
    font-size: 16px;
    font-weight: 700;
  }

  :deep(.join-btn .v-btn__content span) {
    display: block;
    max-width: 100%;
  }
}

/* iPad landscape special case */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .container {
    padding: 12px 0;
    width: 100vw;
    max-width: 100vw;
  }

  .city-header {
    height: 130px;
  }

  .badge-img {
    width: 105px !important;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }
}

/* Desktop wide */
@media (min-width: 1025px) {
  .container {
    padding: 12px 0;
    width: 100%;
    max-width: 100%;
  }

  #v-app-bar--container {
    width: 100%;
    max-width: 100%;
    background-size: contain;
    background-repeat: repeat;
  }

  .city-header {
    height: 130px;
    margin-bottom: 0 !important;
  }

  .badge-img {
    width: 105px !important;
  }

  .city-img {
    width: 50px;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }

  #app-title-container {
    margin-bottom: 0 !important;
  }

  #blue-bar-flex {
    margin-bottom: 0 !important;
  }
}
</style>

<script>
import rpd_menu from "../components/rpd_menu.vue";

export default {
  name: "banner",
  components: { rpd_menu },
  data() {
    return {
      brandbar_show: true,
    };
  },
  mounted() {
    console.log("brand mounted");
  },
};
</script>
